<template>
  <div class="banbenshezhiBox">
    <div key="banbenshezhi" class="banbenshezhi">
      <div class="queryNav">
        <el-button v-if="addFrame" type="primary" size="small" @click="addtukuang">
          添加标准图框
        </el-button>
        <el-button v-if="deleFrame" type="danger" size="small" plain @click="deltukuang">
          删除
        </el-button>
        <el-button v-if="downFrame" :disabled="tukuanggoudel.length != 1" type="primary" size="small" plain
          @click="dowtukuang">
          下载
        </el-button>
      </div>
      <div class="tableBox">
        <el-table ref="multipleTable" :data="tableData2" border tooltip-effect="dark" empty-text="" height="100%"
          @selection-change="selectChange2">
          <template slot="empty">
            <img :src="zanwu" />
            <p style="font-size:16px;color:#000;">
              暂无数据
            </p>
          </template>
          <el-table-column type="selection" align="center">
          </el-table-column>
          <el-table-column label="序号" type="index" width="50">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="文件名称" prop="borderName">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog v-dialogDrag :visible.sync="professionDialogVisible1" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="handlePofessionClose1" title="添加图框"
      custom-class="profession-dialog" width="900px">
      <span>
        <div class="search-header" style="margin-bottom:10px;">
          <el-input v-model="specSearchInput1" placeholder="请输入关键字查询" style="width:200px" size="small" clearable
            @input="addtukaungtable">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <el-table ref="multipleTable" :data="professionData1" border tooltip-effect="dark" style="width: 100%" height="210"
          @selection-change="handleSelectionSpecChange1">
          <template slot="empty">
            <img :src="zanwu" style="height:100px" />
            <p style="font-size:15px;color:#000;">暂无数据</p>
          </template>
          <el-table-column type="selection" align="center"> </el-table-column>
          <el-table-column label="序号" type="index" width="60"> </el-table-column>
          <el-table-column prop="fileName" label="文件名称">
          </el-table-column>
          <el-table-column prop="remark" label="备注"> </el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="professionDialogVisible1 = false">取 消</el-button>
        <el-button :disabled="!tukuanggou.length" type="primary" size="small" @click="confirmAddSpec1">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import requestprj from "@/CommonDP/service/standardPlan-service";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import standardFrame from "@/CommonDP/service/standardDrawingFrame-service";
export default {
  name: "Banbenshezhi",
  data() {
    return {

      prjID: "",
      tableData2: [],
      professionDialogVisible1: false,
      specSearchInput1: "",
      professionData1: [],
      tukuanggou: [],
      tukuanggoudel: [],
      zanwu: require("@/CommonDP/assets/暂无数据.png")
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    addFrame() {
      return checkPermission(this.$allPerms.SETUP_ADD_FRAME);
    },
    deleFrame() {
      return checkPermission(this.$allPerms.SETUP_DELE_FRAME);
    },
    downFrame() {
      return checkPermission(this.$allPerms.SETUP_DOWN_FRAMEE);
    }
  },
  watch: {
    prjInfo: {
      deep: true,
      handler: function({ prjId }, oldValue) {
        if (prjId) {
          this.prjID = this.prjInfo.prjId;
        }
      }
    }
  },
  created() {
    this.prjID = this.prjInfo.prjId;
    this.quertukuang();
  },
  methods: {
    // 标准图框 删除
    selectChange2(val) {
      this.tukuanggoudel = val;
    },
    // 图框表格数据
    quertukuang() {
      var _this = this;
      requestprj.getStandardFiles(_this.prjID, this.enterpriseId).then(res => {
        if (res.result === "0") {
          _this.tableData2 = res.data;
        }
      });
    },
    // 关闭图框 弹框
    handlePofessionClose1() {
      this.professionDialogVisible1 = false;
    },
    // 弹筐里  勾选图框 添加
    handleSelectionSpecChange1(val) {
      this.tukuanggou = val;
    },
    // 确定添加 图框
    confirmAddSpec1() {
      var arr = [];
      for (var i = 0; i < this.tukuanggou.length; i++) {
        arr.push(this.tukuanggou[i].fileId);
      }
      var data = {
        ids: arr,
        prjId: this.prjID
      };
      requestprj.batchAdd(data).then(res => {
        if (res.result === "0") {
          this.$message.success("添加成功");
          this.quertukuang();
          this.professionDialogVisible1 = false;
        }
      });
    },
    // open 图框
    addtukuang() {
      this.professionDialogVisible1 = true;
      this.tukuanggou = [];
      this.specSearchInput1 = "";
      this.addtukaungtable();
    },
    // 添加样本的表格数据
    addtukaungtable() {
      requestprj.getStandardFrameFiles(this.specSearchInput1, this.prjID, this.enterpriseId).then(res => {
        if (res.result === "0") {
          this.professionData1 = res.data;
        }
      });
    },
    // 图框删除
    deltukuang() {
      if (this.tukuanggoudel.length) {
        this.$confirm("此操作将删除选中的图框, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            var arr = [];
            for (var i = 0; i < this.tukuanggoudel.length; i++) {
              arr.push(this.tukuanggoudel[i].borderId);
            }
            var data = {
              prjId: this.prjID,
              ids: arr
            };
            requestprj.batchDelete(data).then(res => {
              if (res.result === "0") {
                this.$message.success("删除成功");
                this.quertukuang();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message.warning("请选择要删除的图框");
      }
    },
    // 图框 下载
    dowtukuang() {
      const fileId = this.tukuanggoudel[0].borderId;
      const fileName = this.tukuanggoudel[0].borderName;
      standardFrame.downloadStandardFrameFile(fileId).then(response => {
        if (response.type === "application/json") {
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            const jsonData = JSON.parse(fileReader.result);
            // 后台信息
            this.$message({ message: jsonData.message, type: "error" });
          };
          fileReader.readAsText(response); // 或者读取response.data
        } else {
          const link = document.createElement("a");
          const blob = new Blob([response], {
            type: "application/octet-stream"
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.banbenshezhiBox {
  width: 100%;
  height: 100%;
  .banbenshezhi {
    height: 100%;
    display: flex;
    flex-direction: column;
    .queryNav {
      margin-bottom: var(--middle-space);
    }
    .tableBox {
      height: 1px;
      flex-grow: 1;
    }
  }
}
</style>
